import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappButton.css";
import { useCountry } from "../utility/utility";

const WhatsappButton = () => {
  const {countryCode} = useCountry();
  const phoneNumber = countryCode === "ae" ? "971562198924" : "917835065469";

  const whatsappLink = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsappButton;
